import { render, staticRenderFns } from "./MuseumsForm.vue?vue&type=template&id=5d5ea128&"
import script from "./MuseumsForm.vue?vue&type=script&lang=js&"
export * from "./MuseumsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports